import CheckoutMixin from './CheckoutMixin';
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { ESubscriptionPlanType, ESubscriptionStep, TSubscriptionStep } from '@/helpers/subscription';
import { Button, Spinner } from 'streamlabs-beaker';
import { EAnalyticsEvent } from '@/helpers/analytic';

@Component({
  components: {
    SButton: Button,
    SSpinner: Spinner,
  },
})
export default class Checkout extends Mixins(CheckoutMixin) {
  @Prop({ default: ESubscriptionStep.choosePlan }) step: TSubscriptionStep;

  @Prop({ default: null, type: String }) modalName: string;

  activeStep: TSubscriptionStep = ESubscriptionStep.choosePlan;

  async mounted() {
    this.activeStep = this.step;
    this.$sla.sendEvent(this.isFreeTrial ? EAnalyticsEvent.checkoutImpressionFreeTrial : EAnalyticsEvent.checkoutImpression, { freeTrial: this.isFreeTrial });
  }

  get choosePlanTitle(): string {
    return this.isFreeTrial ? 'Start a free trial to go live' : 'Choose your plan';
  }

  get choosePlanSubtitle(): string {
    return this.isFreeTrial ? 'Choose a plan and try it for free for 7 days' : 'Select which plan works best for your creation needs.';
  }

  get checkoutButtonText(): string {
    return this.isFreeTrial ? 'Start free trial' : 'Subscribe';
  }

  get saveAmount(): number {
    return Math.ceil(((this.plans[ESubscriptionPlanType.monthly].price * 12) - this.plans[ESubscriptionPlanType.annual].price) / 100);
  }

  get savePercentage(): number {
    return Math.round((1 - (this.plans[ESubscriptionPlanType.annual].price / (this.plans[ESubscriptionPlanType.monthly].price * 12))) * 100);
  }

  goToPayment() {
    if (!this.selectedPlan) this.selectedPlan = ESubscriptionPlanType.annual;
    this.activeStep = ESubscriptionStep.payment;
  }

  async onPaymentSubmit(braintreePayload) {
    await this.processOrder(braintreePayload);

    if (this.modalName) this.$modal.hide(this.modalName);
    if (this.$route.path !== '/projects') this.$router.push('/projects');
  }
}
